type SignOutCardProps = {
  onLogout: () => void;
};

const SignOutCard = ({ onLogout }: SignOutCardProps) => (
  <div className='rounded-[20px] border border-[#E8EAF0] bg-white p-5'>
    <div className='text-[16px] font-semibold text-main mb-3'>Sign out</div>
    <button
      className='w-full flex flex-col items-start gap-0.5 rounded-[12px] bg-[#FEF2F2] border border-[#FECACA] px-4 py-3 hover:bg-[#FEE2E2] transition-colors'
      onClick={onLogout}
    >
      <span className='text-[13px] font-semibold text-[#EF4444]'>→ Sign out</span>
      <span className='text-[11px] text-[#F87171]'>
        You will need to sign in again to access your account.
      </span>
    </button>
  </div>
);

export default SignOutCard;
